import { render, staticRenderFns } from "./LeaveSettingLayout.vue?vue&type=template&id=018f9474&scoped=true"
import script from "./LeaveSettingLayout.vue?vue&type=script&lang=js"
export * from "./LeaveSettingLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018f9474",
  null
  
)

export default component.exports